export function getdata() {
	var obj = {
		headData: [{
				title: "纳税人类型",
				prop: "nsrlx",
				width: 100,
				custom: true,
			},
			{
				title: "土地名称",
				prop: "tudmc",
				custom: true,
				width: 75,
			},
			{
				title: "土地性质",
				prop: "tudxz",
				custom: true,
				width: 75,
			},
			{
				title: "土地取得方式",
				prop: "tudqdfs",
				custom: true,
				width: 100,
			},
			{
				title: "土地用途",
				prop: "tudyt",
				custom: true,
				width: 75,
			},
			{
				title: "土地坐落地址",
				prop: "tudzldz",
				custom: true,
				width: 100,
			},
			{
				title: "土地取得时间",
				prop: "tudqdsj",
				width: 100,
				custom: true,
			},
			{
				title: "占用土地面积",
				prop: "zhanytdmj",
				width: "100",
				custom: true,
				AmountFormat: true,
			},
			{
				title: "土地等级",
				prop: "tuddj",
				custom: true,
				width: 75,
			},
			{
				title: "月减免金额合计",
				prop: "yuejmjehj",
				width: "130",
				custom: true,
				AmountFormat: true,
			},{
				title: "状态",
				prop: "caijFlag",
				width: "120",
				custom: true,
				align: "right"
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		paramsx: {
			nsrlx: '',
			tudsyqNsrsbh: '',
			tudbh: '',
			tudsyqMc: '',
			tudmc: '',
			budcqzh: '',
			budcdydm: '',
			zondh: '',
			tudxz: '',
			tudqdfs: '',
			tudyt: '',
			tudzldzSheng: '',
			tudzldzShi: '',
			tudzldzXian: '',
			tudzldzXiangz: '',
			tudzldzXx: '',
			tudsszgsws: '',
			tudqdsj: '',
			bianglx: '',
			biangsj: '',
			zhanytdmj: '',
			dij: '',
			tuddj: '',
			shuiebz: 0,
			yingnse:0,
			liuslfjmse:0,
			benqyjse: 0,
			suosqqz:'',
			benqybtse:0,
			nsywYxqz:'',
			tuddj:'',
			shuiebz:"",
			nsywYxqq:'',
			jianms: [{
					jianmdmhmc: '',
					jianmqsyf: '',
					jianmzzyf: '',
					tudmj: '',
					jianmje: 0,
				},
				{
					jianmdmhmc: '',
					jianmqsyf: '',
					jianmzzyf: '',
					tudmj: '',
					jianmje: 0,
				},
				{
					jianmdmhmc: '',
					jianmqsyf: '',
					jianmzzyf: '',
					tudmj: '',
					jianmje: 0,
				},
			],
		},
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		tabjson: '{  \"searchList\":[    {      \"name\":\"纳税人类型\",      \"column\":\"nsrlx\",      \"originName\":\"纳税人类型\",      \"show\":\"0\"    },    {      \"name\":\"土地使用权人纳税人识别号\",      \"column\":\"tudsyqNsrsbh\",      \"originName\":\"土地使用权人纳税人识别号\",      \"show\":\"0\"    },    {      \"name\":\"土地使用权人名称\",      \"column\":\"tudsyqMc\",      \"originName\":\"土地使用权人名称\",      \"show\":\"0\"    },    {      \"name\":\"土地编号\",      \"column\":\"tudbh\",      \"originName\":\"土地编号\",      \"show\":\"0\"    },    {      \"name\":\"土地名称\",      \"column\":\"tudmc\",      \"originName\":\"土地名称\",      \"show\":\"0\"    },    {      \"name\":\"不动产权证号\",      \"column\":\"budcqzh\",      \"originName\":\"不动产权证号\",      \"show\":\"0\"    },    {      \"name\":\"不动产单元代码\",      \"column\":\"budcdydm\",      \"originName\":\"不动产单元代码\",      \"show\":\"0\"    },{      \"name\":\"宗地号\",      \"column\":\"zondh\",      \"originName\":\"宗地号\",      \"show\":\"0\"    },    {      \"name\":\"土地性质\",      \"column\":\"tudxz\",      \"originName\":\"土地性质\",      \"show\":\"0\"    },    {      \"name\":\"土地取得方式\",      \"column\":\"tudqdfs\",      \"originName\":\"土地取得方式\",      \"show\":\"0\"    },    {      \"name\":\"土地用途\",      \"column\":\"tudyt\",      \"originName\":\"土地用途\",      \"show\":\"0\"    },    {      \"name\":\"土地坐落地址\",      \"column\":\"tudzldz\",      \"originName\":\"土地坐落地址\",      \"show\":\"0\"    },    {      \"name\":\"土地所属主管税务所\",      \"column\":\"tudsszgsws\",      \"originName\":\"土地所属主管税务所\",      \"show\":\"0\"    },    {      \"name\":\"土地取得时间\",      \"column\":\"tudqdsj\",      \"originName\":\"土地取得时间\",      \"show\":\"0\"    },{      \"name\":\"变更类型\",      \"column\":\"bianglx\",      \"originName\":\"变更类型\",      \"show\":\"0\"    },    {      \"name\":\"变更时间\",      \"column\":\"biangsj\",      \"originName\":\"变更时间\",      \"show\":\"0\"    },    {      \"name\":\"占用土地面积\",      \"column\":\"zhanytdmj\",      \"originName\":\"占用土地面积\",      \"show\":\"0\"    },    {      \"name\":\"地价\",      \"column\":\"dij\",      \"originName\":\"地价\",      \"show\":\"0\"    },    {      \"name\":\"土地等级\",      \"column\":\"tuddj\",      \"originName\":\"土地等级\",      \"show\":\"0\"    },    {      \"name\":\"税额标准\",      \"column\":\"shuiebz\",      \"originName\":\"税额标准\",      \"show\":\"0\"    },    {      \"name\":\"本期应补退税额\",      \"column\":\"benqybtse\",      \"originName\":\"本期应补退税额\",      \"show\":\"0\"    },    {      \"name\":\"本期已缴税额\",      \"column\":\"benqyjse\",      \"originName\":\"本期已缴税额\",      \"show\":\"0\"    },    {      \"name\":\"六费两税减免税额\",      \"column\":\"liuslfjmse\",      \"originName\":\"六费两税减免税额\",      \"show\":\"0\"    },    {      \"name\":\"应纳税额\",      \"column\":\"yingnse\",      \"originName\":\"应纳税额\",      \"show\":\"0\"    },    {      \"name\":\"月减免金额合计\",      \"column\":\"yuejmjehj\",      \"originName\":\"月减免金额合计\",      \"show\":\"0\"    }  ],  \"headData\":[    {      \"name\":\"纳税人类型\",      \"column\":\"nsrlx\",      \"originName\":\"纳税人类型\",      \"show\":\"0\"    },    {      \"name\":\"土地使用权人纳 税人识别号\",      \"column\":\"tudsyqNsrsbh\",      \"originName\":\"土地使用权人纳税人识别号\",      \"show\":\"0\"    },    {      \"name\":\"土地使用权人名称\",      \"column\":\"tudsyqMc\",      \"originName\":\"土地使用权人名称\",      \"show\":\"0\"    },    {      \"name\":\"土地编号\",      \"column\":\"tudbh\",      \"originName\":\"土地编号\",      \"show\":\"0\"    },    {      \"name\":\"土地名称\",      \"column\":\"tudmc\",      \"originName\":\"土地名称\",      \"show\":\"0\"    },    {      \"name\":\"不动产权证号\",      \"column\":\"budcqzh\",      \"originName\":\"不动产权证号\",      \"show\":\"0\"    },    {      \"name\":\"不动产单元代码\",      \"column\":\"budcdydm\",      \"originName\":\"不动产单元代码\",      \"show\":\"0\"    },{      \"name\":\"宗地号\",      \"column\":\"zondh\",      \"originName\":\"宗地号\",      \"show\":\"0\"    },    {      \"name\":\"土地性质\",      \"column\":\"tudxz\",      \"originName\":\"土地性质\",      \"show\":\"0\"    },    {      \"name\":\"土地取得方式\",      \"column\":\"tudqdfs\",      \"originName\":\"土地取得方式\",      \"show\":\"0\"    },    {      \"name\":\"土地用途\",      \"column\":\"tudyt\",      \"originName\":\"土地用途\",      \"show\":\"0\"    },    {      \"name\":\"土地坐落地址\",      \"column\":\"tudzldz\",      \"originName\":\"土地坐落地址\",      \"show\":\"0\"    },    {      \"name\":\"土地所属主管税务所\",      \"column\":\"tudsszgsws\",      \"originName\":\"土地所属主管税务所\",      \"show\":\"0\"    },    {      \"name\":\"土地取得时间\",      \"column\":\"tudqdsj\",      \"originName\":\"土地取得时间\",      \"show\":\"0\"    },{      \"name\":\"变更类型\",      \"column\":\"bianglx\",      \"originName\":\"变更类型\",      \"show\":\"0\"    },    {      \"name\":\"变更时间\",      \"column\":\"biangsj\",      \"originName\":\"变更时间\",      \"show\":\"0\"    },    {      \"name\":\"占用土地面积\",      \"column\":\"zhanytdmj\",      \"originName\":\"占用土地面积\",      \"show\":\"0\"    },    {      \"name\":\"地价\",      \"column\":\"dij\",      \"originName\":\"地价\",      \"show\":\"0\"    },    {      \"name\":\"土地等级\",      \"column\":\"tuddj\",      \"originName\":\"土地等级\",      \"show\":\"0\"    },    {      \"name\":\"税额标准\",      \"column\":\"shuiebz\",      \"originName\":\"税额标准\",      \"show\":\"0\"    },    {      \"name\":\"本期应补退税额\",      \"column\":\"benqybtse\",      \"originName\":\"本期应补退税额\",      \"show\":\"0\"    },    {      \"name\":\"本期已缴税额\",      \"column\":\"benqyjse\",      \"originName\":\"本期已缴税额\",      \"show\":\"0\"    },    {      \"name\":\"六费两税减免税额\",      \"column\":\"liuslfjmse\",      \"originName\":\"六费两税减免税额\",      \"show\":\"0\"    },    {      \"name\":\"应纳税额\",      \"column\":\"yingnse\",      \"originName\":\"应纳税额\",      \"show\":\"0\"    },    {      \"name\":\"月减免金额合计\",      \"column\":\"yuejmjehj\",      \"originName\":\"月减免金额合计\",      \"show\":\"0\"    }  ],  \"formlist\":[    {      \"name\":\"纳税人类型\",      \"column\":\"nsrlx\",      \"originName\":\"纳税人类型\",      \"show\":\"0\"    },    {      \"name\":\"土地使用权人纳税人识别号\",      \"column\":\"tudsyqNsrsbh\",      \"originName\":\"土地使用权人纳税人识别号\",      \"show\":\"0\"    },    {      \"name\":\"土地使用权人名称\",      \"column\":\"tudsyqMc\",      \"originName\":\"土地使用权人名称\",      \"show\":\"0\"    },    {      \"name\":\"土地编号\",      \"column\":\"tudbh\",      \"originName\":\"土地编号\",      \"show\":\"0\"    },    {      \"name\":\"土地名称\",      \"column\":\"tudmc\",      \"originName\":\"土地名称\",      \"show\":\"0\"    },    {      \"name\":\"不动产权证号\",      \"column\":\"budcqzh\",      \"originName\":\"不动产权证号\",      \"show\":\"0\"    },    {      \"name\":\"不动产单元代码\",      \"column\":\"budcdydm\",      \"originName\":\"不动产单元代码\",      \"show\":\"0\"    },{      \"name\":\"宗地号\",      \"column\":\"zondh\",      \"originName\":\"宗地号\",      \"show\":\"0\"    },    {      \"name\":\"土地性质\",      \"column\":\"tudxz\",      \"originName\":\"土地性质\",      \"show\":\"0\"    },    {      \"name\":\"土地取得方式\",      \"column\":\"tudqdfs\",      \"originName\":\"土地取得方式\",      \"show\":\"0\"    },    {      \"name\":\"土地用途\",      \"column\":\"tudyt\",      \"originName\":\"土地用途\",      \"show\":\"0\"    },    {      \"name\":\"土地坐落地址\",      \"column\":\"tudzldz\",      \"originName\":\"土地坐落地址\",      \"show\":\"0\"    },    {      \"name\":\"土地所属主管税务所\",      \"column\":\"tudsszgsws\",      \"originName\":\"土地所属主管税务所\",      \"show\":\"0\"    },    {      \"name\":\"土地取得时间\",      \"column\":\"tudqdsj\",      \"originName\":\"土地取得时间\",      \"show\":\"0\"    },{      \"name\":\"变更类型\",      \"column\":\"bianglx\",      \"originName\":\"变更类型\",      \"show\":\"0\"    },    {      \"name\":\"变更时间\",      \"column\":\"biangsj\",      \"originName\":\"变更时间\",      \"show\":\"0\"    },    {      \"name\":\"占用土地面积\",      \"column\":\"zhanytdmj\",      \"originName\":\"占用土地面积\",      \"show\":\"0\"    },    {      \"name\":\"地价\",      \"column\":\"dij\",      \"originName\":\"地价\",      \"show\":\"0\"    },    {      \"name\":\"土地等级\",      \"column\":\"tuddj\",      \"originName\":\"土地等级\",      \"show\":\"0\"    },    {      \"name\":\"税额标准\",      \"column\":\"shuiebz\",      \"originName\":\"税额标准\",      \"show\":\"0\"    },    {      \"name\":\"本期应补退税额\",      \"column\":\"benqybtse\",      \"originName\":\"本期应补退税额\",      \"show\":\"0\"    },    {      \"name\":\"本期已缴税额\",      \"column\":\"benqyjse\",      \"originName\":\"本期已缴税额\",      \"show\":\"0\"    },    {      \"name\":\"六费两税减免税额\",      \"column\":\"liuslfjmse\",      \"originName\":\"六费两税减免税额\",      \"show\":\"0\"    },    {      \"name\":\"应纳税额\",      \"column\":\"yingnse\",      \"originName\":\"应纳税额\",      \"show\":\"0\"    },    {      \"name\":\"月减免金额合计\",      \"column\":\"yuejmjehj\",      \"originName\":\"月减免金额合计\",      \"show\":\"0\"    }  ]}'
	}
	return obj
}
